/**
 * CONTENT_BY_ID — the merged, exhaustive id→component map for every window.
 *
 * Merges the per-kind content maps (today: TOOL_CONTENT only; gameplay +
 * diagnostic maps slot in here in later phases) into a single
 * `Record<WindowId, React.FC>`. That type is the tsc-level completeness guard:
 * once every kind's map is present, a WindowId with no component anywhere makes
 * the cast unsound and the runtime completeness test (every WINDOW_REGISTRY id
 * resolves to a component) catches it.
 *
 * Hosts (WindowHost, DebugSuiteContainer) read from here — they only render.
 */

import type React from 'react';
import type { WindowId } from './types';
import { TOOL_CONTENT } from './content.tool';
import { DIAGNOSTIC_CONTENT } from './content.diagnostic';
import { GAMEPLAY_CONTENT } from './content.gameplay';

export const CONTENT_BY_ID: Record<WindowId, React.FC> = {
  ...TOOL_CONTENT,
  ...DIAGNOSTIC_CONTENT,
  ...GAMEPLAY_CONTENT,
} as Record<WindowId, React.FC>;
